import React from "react";

import {
  Tooltip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const TooltipCloseContext = React.createContext();

function Action({ onClick, icon, label }) {
  const close = React.useContext(TooltipCloseContext);

  const handleClick = React.useCallback(() => {
    onClick?.();
    close();
  }, [onClick, close]);

  return (
    <ListItem button onClick={handleClick}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText>{label}</ListItemText>
    </ListItem>
  );
}

export default function ActionsTooltip({ children, onRemove, actions }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const open = React.useCallback(() => setIsOpen(true), []);
  const close = React.useCallback(() => setIsOpen(false), []);

  // The Menu component doesn't accept a Fragment as a child.
  const menu = (
    <TooltipCloseContext.Provider value={close}>
      <List dense>{actions.props.children}</List>
    </TooltipCloseContext.Provider>
  );

  return (
    <Tooltip
      open={isOpen}
      onClose={close}
      arrow
      PopperProps={{
        keepMounted: true,
        sx: { "& .MuiTooltip-tooltip": { p: 0, m: 0 } },
      }}
      title={menu}
    >
      <div onMouseEnter={open}>{children}</div>
    </Tooltip>
  );
}

ActionsTooltip.Action = Action;
